import { queryClient } from "@/queryClient"
import { api } from "@/api"

export const deleteCategory = async (
  categoryId: string
): Promise<unknown> => {
  await api.delete(`/products/categories/${categoryId}/`)
  queryClient.invalidateQueries({
    queryKey: [BASE_CATEGORIES_QUERY_KEY],
  })
  queryClient.invalidateQueries({
    queryKey: [BASE_PRODUCTS_QUERY_KEY],
  })
  return
}
